import { render } from "./logo-no-smoking.vue?vue&type=template&id=30da08ec"
import script from "./logo-no-smoking.vue?vue&type=script&lang=js"
export * from "./logo-no-smoking.vue?vue&type=script&lang=js"
script.render = render

export default script